<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Exam Report</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <!-- <add-exam-setup @created="handleCreated"/> -->
        </div>
      </div>
    </div>

    <div class="row card justify-content-center">
      <br />
      <div class="col-xl-12">
        <a-form :form="form">
          <div class="row">
            <!-- Session Select -->
            <div class="col-md-4 mb-2">
              <a-form-item label="Session">
                <a-select
                @change="handleSession"
                  v-decorator="[
                    'session_id',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please select a session!!'
                        }
                      ],
                      initialValue: currentSession ? currentSession.id : ''
                    }
                  ]"
                  placeholder="Select session"
                >
                  <a-select-option
                    v-for="schoolSession in schoolSessions"
                    :value="schoolSession.id"
                    :key="schoolSession.id"
                  >
                    {{ schoolSession.name }}
                    <small class="text-primary ml-3">{{
                      currentSession.id === schoolSession.id ? "Current" : ""
                    }}</small>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <!-- Class Select -->
            <div class="col-md-4 mb-2">
              <a-form-item label="Class">
                <a-spin :spinning="classSpinning">
                  <a-select
                    size="default"
                    v-model="selectedClass"
                    placeholder="All Classes"
                    optionFilterProp="children"
                    style="width: 100%"
                    @change="handleClassSelect"
                    :filterOption="false"
                    :defaultValue="undefined"
                  >
                    <a-select-option :value="undefined"
                      >All Classes</a-select-option
                    >
                    <template v-for="schoolClass in schoolClasses">
                      <a-select-option
                        :value="schoolClass.id"
                        :key="schoolClass.id"
                      >
                        {{ schoolClass.name }}
                      </a-select-option>
                    </template>
                  </a-select>
                </a-spin>
              </a-form-item>
            </div>

            <!-- Section -->
            <div class="col-md-4 mb-2">
              <a-spin :spinning="sectionSpinning">
                <a-form-item label="Section">
                  <a-select
                    size="default"
                    v-model="selectedSection"
                    placeholder="All Sections"
                    optionFilterProp="children"
                    style="width: 100%"
                    @change="handleSectionChange"
                    :filterOption="false"
                    :defaultValue="undefined"
                    :disabled="!selectedClass"
                  >
                    <a-select-option :value="undefined"
                      >All Sections</a-select-option
                    >
                    <template v-for="section in sections">
                      <a-select-option :value="section.id" :key="section.id">
                        {{ section.name }}
                      </a-select-option>
                    </template>
                  </a-select>
                </a-form-item>
              </a-spin>
            </div>

            <!-- Report Card Format PRE to KG and Class-I to Class-X -->
            <div class="col-md-4 mb-2">
              <a-form-item label="Choose Report Card Format">
                <a-radio-group @change="getFormat"
                  v-decorator="[
                    'report_card_format',
                    {
                      rules: [
                        { required: true, message: 'This value is required' }
                      ],
                      initialValue: 1
                    }
                  ]"

                >
                  <a-radio :value="2">PRE to KG</a-radio>
                  <a-radio :value="1">Class-I to Class-X</a-radio>
                </a-radio-group>
              </a-form-item>
            </div>
            <div class="col-md-8 mb-2" v-if="selectedSection">
              <a-form-item label="Class Exams">
                <a-spin :spinning="examLoading">
                  <a-checkbox-group
                    v-decorator="[
                      'class_exams',
                      {
                        rules: [
                          {
                            required: true,
                            message: 'Please select exams!!'
                          }
                        ],
                        initialValue: []
                      }
                    ]"
                    @change="handleSectionExamSelect"
                  >
                    <template class="col-4" v-for="examlist in schoolExams">
                      <a-checkbox :value="examlist.id" :key="examlist.id">
                        {{ examlist.exam.name }}
                      </a-checkbox>
                    </template>
                  </a-checkbox-group>
                </a-spin>
              </a-form-item>
            </div>
            <div class="col-md-8 mb-2" v-else>
              <a-form-item label="Class Exams">
                <i style="color: blue"
                  >( Please select class and section to get exam )</i
                >
              </a-form-item>
            </div>
            <!-- Bulk report card  Button-->
            <div class="col-md-4 mb-2"></div>
            <div class="col-md-4 mb-2"></div>
            <div class="col-md-4 mb-2 text-right">
              <a-spin :spinning="downloadLoading">
              <a-button type="primary" icon="printer" @click="handleBulkReportCard" :disabled='!this.showButton'>
                Print Bulk Report card
              </a-button>
              <br>
<!--              <a-button type="primary" icon="download" id="BulkReportDownload" @click="downloadBulkReportCard" :disabled='!this.showButton' style="margin-top:10px">-->
<!--                Download Bulk Report card-->
<!--              </a-button>-->
              </a-spin>
            </div>
          </div>
        </a-form>
        <div class="card">
          <hr />
          <div class="card-body" v-if="this.checkedClassId.length === 0">
            <no-data text="Please select section and exams!" />
          </div>
          <div class="card-body" v-else>
            <a-spin :spinning="loading">
            <display-student-exam-report
              :classId="selectedClass"
              :sectionId="selectedSection"
              :examData="classSectionExamData"
              :selectedExamId="studentClassSelectedExam"
              :selectedReportCardFormat="selectedReportCardFormat"
              :sessionId="selectedSession"
            />
            </a-spin>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { find } from 'lodash'
import moment from 'moment'
import DisplayStudentExamReport from '@/components/bosemexam/manage/BethelReport/index'
import NoData from '@/components/layout/NoData/index'
export default {
  name: 'ExamReport',
  components: {
    DisplayStudentExamReport,
    NoData,
  },
  mounted: function() {
    this.$http
      .get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
        this.selectedSession = find(data.data, ['is_current', 1]).id
        this.getClasses()
      })
      .catch(error => {
        console.log(error)
      })
  },
  computed: {
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
  },
  watch: {
    seletedClassName: function(value) {
      return value
    },
    seletedSectionName: function(value) {
      return value
    },
    showButton: function(value) {
      return value
    },
    selectedReportCardFormat: function(value) {
      return value
    },
    checkedClassId: function(value) {
      return value
    },
    currentSession: function(val) {
      this.selectedSession = val.id
    },
    class_Id: function(value) {
      return value
    },
    section_Id: function(value) {
      return value
    },
    classSectionExamData: function(value) {
      return value
    },
    studentClassSelectedExam: function(value) {
      return value
    },
    schoolExams: function(value) {
      return value
    },
    isAllSections: function(val) {
      if (val) {
        this.form.setFieldsValue({ sections: [0] })
      }
    },
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      checkedClassId: [],
      loading: false,
      visible: false,
      examLoading: false,
      schoolExams: [],
      schoolClasses: [],
      sections: [],
      schoolSessions: [],
      classSubjects: [],
      selectedSession: undefined,
      isAllSections: true,
      classSpinning: false,
      sectionSpinning: false,
      subjectSpinning: false,
      dateFormat: 'DD-MM-YYYY',
      timeFormat: 'h:mm a',
      showMarkField: false,
      enabled_status: 'Disabled',
      show_columns: true,
      changeData: '',
      exams: [],
      studentClassSelectedExam: null,
      class_Id: '',
      section_Id: '',
      class_Name: '',
      search: '',
      data: [],
      meta: [],
      status: false,
      current: 1,
      pageSize: 10,
      selectedClass: undefined,
      selectedSection: undefined,
      classSectionExamData: null,
      selectedReportCardFormat: 1,
      showButton: false,
      bulkExams: [],
      downloadLoading: false,
      seletedClassName: '',
      seletedSectionName: '',
    }
  },
  methods: {
    moment,
    handleSession(e) {
      this.selectedClass = undefined
      this.selectedSection = undefined
      this.selectedSession = e
      this.getClasses(e)
    },
    getFormat(e) {
      this.selectedReportCardFormat = e.target.value
    },
    getClasses: function(selSessId) {
      this.classSpinning = true
      this.$http
        .get('/api/class', {
          params: {
            session_id: selSessId,
          },
        })
        .then(({ data }) => {
          this.schoolClasses = data.data
          this.classSpinning = false
        })
        // .catch(error => {
        //   console.log(error);
        // });
    },
    handleClassSelect(value) {
      let obj = this.schoolClasses.find(d => d.id === value)
      this.seletedClassName = obj.name
      this.selectedSection = undefined
      this.showButton = false
      if (value) {
        this.sectionSpinning = true
        this.getClassSections(value)
      }
    },
    getClassSections(value) {
      this.$http
        .get(`/api/section/class/${value}`, {
          params: {
            session_id: this.selectedSession,
          },
        })
        .then(({ data }) => {
          this.sections = data.data
          this.sectionSpinning = false
        })
        // .catch(error => {
        //   console.log(error);
        // });
    },
    handleSectionChange(value) {
      if (value) {
        let obj = this.sections.find(d => d.id === value)
        this.seletedSectionName = obj.name
        this.form.resetFields([`class_exams`])
        this.classSectionExamData = []
        this.selectedSection = value
        this.examLoading = true
        this.loading = true
        this.showButton = false
        this.$http
          .get('/api/classsectionexam', {
            params: {
              session_id: this.selectedSession,
              class_id: this.selectedClass,
              section_id: this.selectedSection,
              limit: this.pageSize,
              page: this.current,
            },
          })
          .then(({ data }) => {
            this.examLoading = false
            this.schoolExams = data.data.filter(obj => obj.declared === 1)
            // console.log(this.schoolExams)
            this.checkedClassId = ''
            this.meta = data.meta
          })
      }
    },
    getExamId() {
      this.bulkExams = []
      var response = []
      var arrayDatas = []
      arrayDatas = this.checkedClassId
      const exams = this.schoolExams
      arrayDatas.forEach(function(value) {
        var foundValue = exams.filter(obj => obj.id === value)
        var responseData = Object.assign({}, ...foundValue).exam.id
        response.push(responseData)
      })
      this.bulkExams = response
    },
    handleSectionExamSelect: function(e) {
      this.checkedClassId = e
      if (this.checkedClassId.length === 0) {
        this.showButton = false
      } else {
        this.showButton = true
        this.studentClassSelectedExam = e
        this.loading = true
        this.$http
          .get(`/api/classsectionexam/${this.checkedClassId}`, {
            params: {
              with_students: 1,
              class_section_exam_id: this.checkedClassId,
              session_id: this.selectedSession,
            },
          })
          .then(({ data }) => {
            this.classSectionExamData = data.data
            this.loading = false
            this.getExamId()
          })
          .catch(error => {
            this.loading = false
            this.$neoNotify.error(error)
          })
      }
      // this.getClassExamData(this.checkedClassId);
    },
    // bulk report card redirect page
    handleBulkReportCard() {
      this.$router.push({
        name: 'bulkreportcard',
        params: {
          classId: this.selectedClass,
          sectionId: this.selectedSection,
          examsId: this.bulkExams,
          sessionId: this.selectedSession,
          reportFormat: this.selectedReportCardFormat,
        },
      })
    },
    disabledDate(current) {
      // Can not select days before today
      return current < moment().startOf('day')
    },
    // downloadBulkReportCard() {
    //   this.downloadLoading = true
    //   this.$http
    //     .get(
    //       '/api/reports/bosem/export',
    //       {
    //         headers: {
    //           'content-type': 'application/json',
    //           'Accept': 'application/json',
    //         },
    //         params: {
    //           template_type: this.selectedReportCardFormat,
    //           class_id: this.selectedClass,
    //           section_id: this.selectedSection,
    //           exams: this.bulkExams,
    //         },
    //         responseType: 'arraybuffer',
    //       },
    //     )
    //     .then((response) => {
    //       // new tab open
    //       // let blob = new Blob([response.data], { type: 'application/pdf' })
    //       // let url = window.URL.createObjectURL(blob)
    //       // window.open(url)
    //       // this.downloadLoading = false
    //       // auto download
    //       let blob = new Blob([response.data], {
    //         type: 'application/json',
    //       })
    //       this.downloadLoading = false
    //       this.$notification['info']({
    //         message: 'Bulk report card download started!',
    //         description: `Bulk report card  has started! Please check once it is completed!`,
    //       })
    //
    //       let link = document.createElement('a')
    //       link.href = window.URL.createObjectURL(blob)
    //       link.download = 'exam_report_' + this.seletedClassName + '_' + this.seletedSectionName + '.pdf'
    //       link.click(link)
    //     })
    //     .catch((error) => {
    //       this.loading = false
    //       this.$neoNotify.error(error)
    //     })
    // },
  },
}
</script>
